export default __webpack_public_path__ + "static/media/RetinSight-BG-People.749c6c6f.jpg";